// 偈語/佛學句填字題庫
// chars: 所有出現在文字池的字（含答案字與干擾字），順序會被打亂
// answer: 正確答案（依序排列）
// hint: 題目提示文字
export const PUZZLES = [
  {
    id: 1,
    hint: '以下哪句描述「燈」的功德？',
    answer: ['譬', '如', '一', '燈', '燃', '百', '千', '燈'],
    chars: [
      '譬', '如', '一', '燈', '燃', '百', '千', '燈',
      '水', '月', '花', '空', '心', '佛', '法', '僧',
      '慈', '悲', '喜', '捨', '戒', '定', '慧', '忍',
      '善', '緣', '願', '行', '苦', '集', '滅', '道',
      '無', '常', '我', '淨', '明', '覺', '智', '德',
      '光', '照', '大', '千', '福', '壽', '安', '樂',
      '清', '靜',
    ],
  },
  {
    id: 2,
    hint: '以下哪句說明「心」的重要？',
    answer: ['制', '心', '一', '處', '無', '事', '不', '辦'],
    chars: [
      '制', '心', '一', '處', '無', '事', '不', '辦',
      '燈', '月', '花', '空', '佛', '法', '僧', '慈',
      '悲', '喜', '捨', '戒', '定', '慧', '忍', '善',
      '緣', '願', '行', '苦', '集', '滅', '道', '常',
      '我', '淨', '明', '覺', '智', '德', '光', '照',
      '大', '千', '福', '壽', '安', '樂', '清', '靜',
      '正', '念',
    ],
  },
  {
    id: 3,
    hint: '佛陀開示「覺」的境界？',
    answer: ['自', '覺', '覺', '他', '覺', '行', '圓', '滿'],
    chars: [
      '自', '覺', '覺', '他', '覺', '行', '圓', '滿',
      '燈', '月', '花', '空', '心', '佛', '法', '僧',
      '慈', '悲', '喜', '捨', '戒', '定', '慧', '忍',
      '善', '緣', '願', '苦', '集', '滅', '道', '無',
      '常', '我', '淨', '明', '智', '德', '光', '照',
      '大', '千', '福', '壽', '安', '樂', '清', '靜',
      '正', '念',
    ],
  },
];

export const MAX_WRONG_ATTEMPTS = 3;
